import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=73dda90c&scoped=true&lang=pug"
import script from "./add-or-update.vue?vue&type=script&lang=js"
export * from "./add-or-update.vue?vue&type=script&lang=js"
import style0 from "./add-or-update.vue?vue&type=style&index=0&id=73dda90c&prod&scoped=true&lang=css"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=73dda90c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dda90c",
  null
  
)

export default component.exports